// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__26PaV","detailsBorder":"styles_detailsBorder__3Qo2a"};